import React, { useState } from "react";

import OldGhaleru from "./OldGhaleru";
import NewGhaleru from "./NewGhaleru";
import Option from "../Option";
import BackButton from "../../../../../components/common/backbutton/BackButton";

const GhareluRenew = () => {
  const [turnOn, setTurnOn] = useState(true)



  return (
    <div className="px-10 lg:!px-14">
        <p className="text-primary-red font-Rakkas mt-7 text-center  font-semibold tracking-wide underline md:!text-3xl">
          Gharelu Renewals
        </p>
        <Option setTurnOn={setTurnOn}/>
      
        <div className="flex justify-between my-3">
          <p className="text-primary-blue font-Calistoga text-lg underline">
            1. Business Name & Other Details
          </p>
        </div>

    {  
     turnOn ?
        <OldGhaleru/>:
       <NewGhaleru/>
       
    }


      
    </div>
  );
};

export default GhareluRenew;
